<template>
  <b-overlay :show="isLoading">
    <b-row v-if="blogDetails">
      <b-col cols="12">
        <b-card>
          <h1>Edit {{ blogTitle }}</h1>
          <hr class="mb-3" />
          <b-row>
            <b-col cols="12">
              <b-form @submit.prevent>
                <b-form-group label="Blog Title" label-for="title">
                  <b-form-input
                    :state="titleState"
                    id="title"
                    v-model="blogDetails.title"
                    trim
                    placeholder="Enter blog title"
                  />
                  <b-form-invalid-feedback>
                    <div
                      class="w-100 d-flex align-items-center justify-content-between"
                    >
                      <p>Title Field Should Not Exceed 200 Charachters</p>
                      <template
                        v-if="
                          blogDetails &&
                          blogDetails.title &&
                          blogDetails.title.length > 0
                        "
                      >
                        {{ blogDetails.title.length }}/200
                      </template>
                    </div>
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col cols="6" class="my-1">
              <b-form @submit.prevent>
                <b-form-group  label="Blog Publish Status" label-for="blogStatus">
                  <b-form-select
                    id="blogStatus"
                    v-model="blogDetails.status"
                    :options="blogStatusEnums"
                  ></b-form-select>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col cols="6" class="my-1">
              <blog-category-picker
                :defaultCategory="blogDetails.blogCategoryId"
                @getBlogCategory="setBlogCategory"
              ></blog-category-picker>
            </b-col>
<!--            <b-col cols="2">-->
<!--              <b-form-group-->
<!--                label-for="allowComments"-->
<!--                label="درج نظر برای نوشته"-->
<!--                class="mt-2"-->
<!--              >-->
<!--                <div class="d-flex align-items-center">-->
<!--                  <span style="margin-left: 8px"> خیر </span>-->
<!--                  <b-form-checkbox-->
<!--                    id="allowComments"-->
<!--                    switch-->
<!--                    v-model="blogDetails.allowComments"-->
<!--                  ></b-form-checkbox>-->
<!--                  بله-->
<!--                </div>-->
<!--              </b-form-group>-->
<!--            </b-col>-->
            <b-col cols="12">
              <b-form @submit.prevent>
                <b-form-group label="Blog Summary" label-for="summary">
                  <b-form-textarea placeholder="Aria Export..."
                    id="summary"
                    v-model="blogDetails.summary"
                    :state="summaryState"
                  ></b-form-textarea>
                  <b-form-invalid-feedback>
                    <div
                      class="w-100 d-flex align-items-center justify-content-between"
                    >
                      <p>Summary Field Should Not Exceed 400 Charachters</p>
                      <template
                        v-if="
                          blogDetails &&
                          blogDetails.summary &&
                          blogDetails.summary.length > 0
                        "
                      >
                        {{ blogDetails.summary.length }}/400
                      </template>
                    </div>
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col cols="12">
              <small>Blog Content</small>
              <quillEditor
                ref="quillEditor"
                class="mt-1"
                v-model="blogDetails.description"
                :options="editorOption"
              >
                <div id="toolbar" slot="toolbar" class="ql-toolbar ql-snow">
                  <quill-toolbar></quill-toolbar>
                </div>
              </quillEditor>
            </b-col>
            <b-col cols="6" class="my-1">
              <b-form @submit.prevent>
                <b-form-group label="Blog Cover" label-for="imageFile">
                  <b-form-file
                    id="imageFile"
                    v-model="blogImage"
                    accept="image/*"
                    @input="convertImageFileToBase64"
                  ></b-form-file>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col cols="6" class="my-1">
              <div v-if="blogImage">
                <p>Blog Image Preview</p>
                <div class="position-relative">
                  <img
                    style="width: 100%; max-height: 20rem; object-fit: contain"
                    :src="imagePreview"
                    alt=""
                  />
                  <feather-icon
                    icon="Trash2Icon"
                    size="25"
                    class="text-danger position-absolute"
                    style="left: 1rem; top: 1rem; cursor: pointer"
                    @click="deletePreviewImage"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="12">
              <div class="d-flex align-items-center justify-content-end">
                <b-button
                  type="button"
                  variant="success"
                  @click="updateThisBlog"
                >
                  Update Blog
                </b-button>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <library-image-picker
      @insertImage="insertImage"
      @insertVideo="insertVideo"
    ></library-image-picker>
  </b-overlay>
</template>
<script>
import BlogCategoryPicker from "@/views/components/Blog/BlogCategoryPicker.vue";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import { GetASingleBlog, UpdateABlog } from "@/libs/Api/Blog";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import QuillToolbar from "@/views/components/utils/QuillToolbar.vue";
import {
  BFormInvalidFeedback,
  BCard,
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BFormCheckbox,
  BFormFile,
  BFormSelect,
  BFormTextarea,
  BButton,
  BPagination,
  BOverlay,
} from "bootstrap-vue";
import LibraryImagePicker from "@/views/components/utils/LibraryImagePicker.vue";
import mainBaseUrl from "@/global-components";
import Helper from "@/libs/Helper";
export default {
  title: "Edit blog",
  mounted() {
    this.getASingleBlog();
  },
  data() {
    return {
      isLoading: false,
      blogDetails: null,
      blogImage: null,
      blogTitle: null,
      blogStatusEnums: [
        {
          text: "Published",
          value: 1,
        },
        {
          text: "Archive",
          value: 2,
        },
      ],
      editorOption: {
        modules: {
          toolbar: {
            container: "#toolbar",
            handlers: {
              image: this.imageMethod,
              video: this.imageMethod,
            },
          },
        },
        // Some Quill options...
        theme: "snow",
      },
    };
  },
  methods: {
    imageMethod() {
      this.$bvModal.show("library-image-picker-modal");
    },
    insertImage(imageUrl) {
      this.$refs.quillEditor.quill.insertEmbed(
        this.$refs.quillEditor.quill.getSelection().index,
        "image",
        imageUrl
      );
    },
    insertVideo(videoUrl) {
      this.$refs.quillEditor.quill.insertEmbed(
        this.$refs.quillEditor.quill.getSelection().index,
        "video",
        videoUrl
      );
    },
    async updateThisBlog() {
      try {
        this.isLoading = true;
        let _this = this;
        if (!this.blogDetails.seourl.startsWith("/")) {
          this.blogDetails.seourl = `/${this.blogDetails.seourl}`;
        }
        let updateABlog = new UpdateABlog(_this);
        updateABlog.setRequestParamDataObj(_this.blogDetails);
        await updateABlog.fetch((response) => {
          if (response.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "Operation successful.",
                icon: "EditIcon",
                variant: "success",
              },
            });
            _this.getASingleBlog();
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async getASingleBlog() {
      try {
        this.isLoading = true;
        let _this = this;
        let getASingleBlog = new GetASingleBlog(_this);
        getASingleBlog.setRequestParam({
          id: _this.$route.params.id,
        });
        await getASingleBlog.fetch((response) => {
          if (response.isSuccess) {
            _this.blogDetails = response.data;
            _this.blogTitle = JSON.parse(JSON.stringify(response.data.title));
            _this.blogImage = JSON.parse(
              JSON.stringify(response.data.imageFile)
            );
            _this.blogDetails.imageFile = null;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    deletePreviewImage() {
      this.blogImage = null;
      this.blogDetails.imageFile = "delete";
    },
    convertImageFileToBase64() {
      const reader = new FileReader();
      reader.readAsDataURL(this.blogImage);
      reader.onload = () => {
        this.blogDetails.imageFile = reader.result.split(",")[1];
      };
    },
    setBlogCategory(categoryId) {
      this.blogDetails.blogCategoryId = categoryId;
    },
  },
  computed: {
    imagePreview() {
      if (
        this.blogImage &&
        this.blogImage != "delete" &&
        typeof this.blogImage != "string"
      ) {
        return URL.createObjectURL(this.blogImage);
      } else {
        return `${Helper.baseUrl}/${this.blogImage}`;
      }
    },
    titleState() {
      if (this.blogDetails && this.blogDetails.title) {
        if (this.blogDetails.title.length > 200) {
          return false;
        } else if (this.blogDetails.title.length < 200) {
          return true;
        }
      } else {
        return null;
      }
    },
    summaryState() {
      if (this.blogDetails && this.blogDetails.summary) {
        if (this.blogDetails.summary.length > 400) {
          return false;
        } else if (this.blogDetails.summary.length < 400) {
          return true;
        }
      } else {
        return null;
      }
    },
    isCreateButtonDisabled() {
      if (this.summaryState && this.titleState) {
        return false;
      }
      return true;
    },
  },
  components: {
    BlogCategoryPicker,
    quillEditor,
    BCard,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BFormCheckbox,
    BInputGroupAppend,
    BFormFile,
    BFormSelect,
    BFormTextarea,
    BButton,
    BPagination,
    BOverlay,
    BFormInvalidFeedback,
    LibraryImagePicker,
    QuillToolbar,
  },
};
</script>
